import { render } from "./IconItemCategoryOutdoor.vue?vue&type=template&id=c3ad4fca"
import script from "./IconItemCategoryOutdoor.vue?vue&type=script&lang=js"
export * from "./IconItemCategoryOutdoor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__